import React, { useEffect, useState } from "react";
import {
  Button,
  List,
  ListItem,
  ListItemText,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Switch,
  Tooltip,
} from "@material-ui/core";
import { DeleteButton } from "../../../components/ButttonsWithIcons";
import { AddNewAreaDialog } from "./component/addNewAreaDialog";
import { getTranslation } from "../../../heplers/translationHelper";
import { useSnackbar } from "notistack";
import { Post } from "../../../actions";

export const AreaList = ({ areas, selectedArea, onDeleteArea, onAreaChange, onAddNewarea, onToggleArea }) => {
  const [openDialog, setOpenDialog] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [areaToDelete, setAreaToDelete] = useState(null); // For confirmation dialog
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if (areas?.length && !selectedArea) {
      onAreaChange(areas[0]);
    }
  }, [areas, selectedArea]);
  

  const handleDeleteArea = (area) => {
    setIsDeleting(true);
    console.log("Attempting to delete area:", area.id);

    Post({}, `TableManagement/DeleteArea?id=${area.id}`, null,
      (res) => {
        console.log("Delete successful:", res);
        setIsDeleting(false);
        enqueueSnackbar(
          getTranslation("Deleted Successfully", "Deleted Successfully", "Deleted Successfully"),
          { variant: "success" }
        );
        onDeleteArea(area);
      },
      (err) => {
        console.error("Delete failed:", err);
        setIsDeleting(false);
        enqueueSnackbar(getTranslation(err?.data || "Delete failed"), {
          variant: "error",
        });
      }
    );
  };

  return (
    <Box boxShadow={6} borderRadius={4} p={2} style={{ width: "300px", marginRight: "20px" }}>
      {onAddNewarea ? (
        <>
          <h3 style={{ marginBottom: "9px", fontWeight: "550" }}>
            {getTranslation("Add Area", "Add Area", "Add Area")}
          </h3>
          <Button

            variant="contained"
            color="primary"
            fullWidth
            onClick={() => setOpenDialog(true)}
          >
            {getTranslation("Add", "Add", "Add")}
          </Button>
        </>
      ) : null}

      <List>
        {areas.map((area) => (
          <ListItem
            button
            key={area.id}
            style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
            selected={area.id == selectedArea?.id}
            onClick={() => onAreaChange(area)}
          >
            <ListItemText
              primary={area.title}
              secondary={
                onToggleArea
                  ? area.isOpen === false
                    ? getTranslation("Closed", "Fermée", "Geschlossen")
                    : getTranslation("Open", "Ouverte", "Geöffnet")
                  : null
              }
              style={{ opacity: area.isOpen === false ? 0.5 : 1 }}
            />
            {onToggleArea && (
              <Tooltip
                title={getTranslation(
                  "Open / close this room for reservations",
                  "Ouvrir / fermer cette salle aux réservations",
                  "Diesen Raum für Reservierungen öffnen / schließen"
                )}
              >
                <Switch
                  size="small"
                  color="primary"
                  checked={area.isOpen !== false}
                  onClick={(e) => e.stopPropagation()}
                  onChange={(e) => onToggleArea(area, e.target.checked)}
                />
              </Tooltip>
            )}
            {onDeleteArea && (
              <DeleteButton
                onClick={(e) => {
                  e.stopPropagation(); 
                  setAreaToDelete(area); 
                }}
              />
            )}
          </ListItem>
        ))}
      </List>

      <AddNewAreaDialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        onSubmit={onAddNewarea}
      />

      {/* Confirmation Dialog */}
      <Dialog open={!!areaToDelete} onClose={() => setAreaToDelete(null)}>
        <DialogTitle>
          {getTranslation("Confirm Delete", "Confirm Delete", "Confirm Delete")}
        </DialogTitle>
        <DialogContent>
          {getTranslation(
            "Are you sure you want to delete this area?",
            "Are you sure you want to delete this area?",
            "Are you sure you want to delete this area?"
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setAreaToDelete(null)} color="default">
            {getTranslation("Cancel", "Cancel", "Cancel")}
          </Button>
          <Button
            onClick={() => {
              handleDeleteArea(areaToDelete);
              setAreaToDelete(null);
            }}
            color="secondary"
            variant="contained"
            disabled={isDeleting}
          >
            {getTranslation("Delete", "Delete", "Delete")}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};
